import { Component, OnInit, ViewChild } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import interactionPlugin, { ThirdPartyDraggable } from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput } from '@fullcalendar/core';
import { PlannerService } from '../root/_services/planner.service';
import { AlertService } from '../root/_services/alert.service';

declare var $;

@Component({
	selector: 'app-test-scheduler',
	templateUrl: './test-scheduler.component.html',
	styleUrls: ['./test-scheduler.component.scss']
})
export class TestSchedulerComponent implements OnInit {

	@ViewChild("calendarDatepicker") calendarDatepicker: FullCalendarComponent;
	@ViewChild("calendarTimeline") calendarTimeline: FullCalendarComponent;

	calendarDatepickerPlugins = [interactionPlugin, dayGridPlugin, timeGridPlugin, bootstrapPlugin, momentPlugin];
	calendarDatepickerHeader = { left: 'prev', center: 'title', right: 'next' };
	calendarTimelinePlugins = [interactionPlugin, dayGridPlugin, timeGridPlugin, resourceTimeGridPlugin, bootstrapPlugin];
	calendarTimelineHeader = { left: 'prev', center: 'title', right: 'next' };

	currentDate: string = "20200323";
	showCalendar: boolean = true;
	entityType: string = "vehicles";
	resourcesTimeline: Array<any>;

	constructor(
		private plannerService: PlannerService,
		private alertService: AlertService
	) { }

	ngOnInit() {
	}

	setDate(date) {
		console.log(date);
		if (date) {
			this.currentDate = date.replace(/-/gi, "");
			this.calendarDatepicker.getApi().gotoDate(date);
			this.calendarTimeline.getApi().gotoDate(date);
		}
	}

	resourceRender(r: any) {
		//console.log("resourceRender");
		//console.log(r);
		var img = new Image(40, 40);
		img.src = 'https://picsum.photos/id/885/40/40';
		img.classList.add('rounded');
		r.el.style.width = "91px";
		r.el.prepend(img);
	}

	eventRender(info: any) {
		console.log("resourceRender");
		console.log(info);
		info.el.classList.add(info.event.extendedProps.status);
		//console.log(info);
		info.el.style.width = '91px';

		var id = info.event.id;
		info.el.id = "event-" + id;

		var timeBefore, timeAfter;

		timeBefore = info.event.extendedProps.timeBefore;
		timeAfter = info.event.extendedProps.timeAfter;


		if (timeBefore != null && timeAfter != null) {
			console.log(timeBefore, timeAfter);
			info.el.classList.add(timeBefore);
			info.el.classList.add(timeAfter);
		} else {


		}

		$(".fc-view.fc-resourceTimeGridDay-view.fc-timeGrid-view").css('width', $('.fc-resource-cell').length * 110);

	}

	getResources = (fetchInfo, successCallback, failureCallback) => {
		console.log("getResources");
		this.loadResources(fetchInfo, successCallback, failureCallback);
	}

	getEvents = (fetchInfo, successCallback, failureCallback) => {
		console.log("getEvents");
		this.loadEvents(fetchInfo, successCallback, failureCallback);
	}

	loadResources(fetchInfo, successCallback, failureCallback) {
		console.log(fetchInfo);
		if (this.resourcesTimeline)
			successCallback(this.resourcesTimeline);
		else {
			this.currentDate = fetchInfo.startStr.substring(0, 10).replace(/-/gi, "");
			if (this.currentDate) {
				this.plannerService.getAssigned(this.entityType, this.currentDate).subscribe(
					res => {
						if (res.status == "OK") {
							if (res.result.lista) {
								const resources = [];
								(<Array<any>>res.result.lista).forEach(
									x => resources.push({
										id: x.id,
										title: this.entityType == "vehicles" ? x.modello.marca + " " + x.modello.modello : x.cognome
									}));
								console.log(resources);
								this.resourcesTimeline = resources;
								successCallback(resources);
							}
							else
								failureCallback("SYSTEM ERROR");
						}
						else if (res.error_message)
							failureCallback(res.error_message);
						else
							failureCallback("SYSTEM ERROR");
					}
				);
			}
		}
	}

	loadEvents(fetchInfo, successCallback, failureCallback) {
		console.log(fetchInfo);
		this.currentDate = fetchInfo.startStr.substring(0, 10).replace(/-/gi, "");
		if (this.currentDate) {
			this.plannerService.getAssigned(this.entityType, this.currentDate).subscribe(
				res => {
					if (res.status == "OK") {
						if (res.result.servizi) {
							const events = <Array<EventInput>>[];
							(<Array<any>>res.result.servizi).forEach(
								x => events.push({
									id: x.id,
									resourceId: this.entityType == "vehicles" ? x.idVeicolo : x.idAutista,
									title: x.tipoServizio.nome + " #" + x.numero,
									start: x.dataOraInizioServizio,
									end: x.dataOraFineServizio,
									extendedProps: {
										status: "assigned"
									}
								}));
							console.log(events);
							successCallback(events);
						}
						else
							failureCallback("SYSTEM ERROR");
					}
					else if (res.error_message)
						this.alertService.error(res.error_message);
					else
						this.alertService.error("SYSTEM ERROR");
				}
			);
		}
	}

	dayRender(dayRenderInfo) {
		console.log("dayRenderInfo");
		console.log(dayRenderInfo);
		const date = dayRenderInfo.date;
		if (date)
			this.currentDate = dayRenderInfo.date.toString().replace(/-/gi, "");
	}


}
